module.exports = __webpack_public_path__ + "static/img/ai-background.0d21b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ai-dialog/ai-background.png
// module id = A5VP
// module chunks = 62